const getters = {
  getErrorMessage: state => {
    return state.errorMessage;
  }
};

export default getters;
